import React, { useState } from 'react'
import { useShowContext, useRefresh } from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import terminalProvider from '../../../../core/devices/terminals/terminals.provider'
import { TerminalDto } from '../../../../core/dto/device/terminals/terminal.dto'
import { PrintParkingTicketDialog } from '../TerminalDialogs'

export const TerminalPrintTicketButton = () => {
  const { loading, record: terminal } = useShowContext<TerminalDto>()
  const [noteDialogOpen, setNoteDialogOpen] = useState(false)
  const [note, setNote] = useState<string>()
  const hasAuthority = useHasAuthority()
  const refresh = useRefresh()

  const handleOpenDialog = () => {
    setNoteDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setNote(undefined)
    setNoteDialogOpen(false)
  }

  const handlePrintParkingTicket = async () => {
    await terminalProvider.printParkingTicket(ResourceName.TERMINALS, {
      terminalId: terminal?.id as number,
      note: note as string,
    })
    refresh()
  }

  return (
    <>
      <PrintParkingTicketDialog
        open={noteDialogOpen}
        close={handleCloseDialog}
        note={note}
        setNote={setNote}
        handleOpen={handlePrintParkingTicket}
      />
      <Button
        size="small"
        variant="contained"
        color="primary"
        label="resources.terminals.actions.printParkingTicket"
        useSmallVersionBreakpoint={false}
        onClick={handleOpenDialog}
        disabled={!hasAuthority(Authority.TERMINALS_PRINT_TICKET) || loading}
      />
    </>
  )
}
